import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { AuthResponseModel } from '../../Models/Authentication/AuthResponse';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';


@Component({
  selector: 'app-get-user-intersets',
  templateUrl: './get-user-intersets.component.html',
  styleUrls: ['./get-user-intersets.component.css'],standalone:false
})
export class GetUserIntersetsComponent extends BaseComponent implements OnInit{
  formGroup!: FormGroup;
  interests: string[] = [];
  selectedInterests: string[] = [];
  userId:string=''
  errorMessage: string = '';
  loading:boolean=false;
  userRole:string=''
  user1:string=''
  authResponse!:AuthResponseModel
  constructor
  (
        private fb: FormBuilder,
        private auth:AuthService,
        private api: BaseApiService,
        private messageService:MessageService
  )
  {
    super();
    this.userId=this.auth.getUID();
    this.userRole=this.auth.getRoles().toString();
  }

  GetAll(uid:any)
  {
    this.loading=true;
    this.api.read(`Auth/GetUserInterest?username=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe
    (
      {
        next: (response)=>{
          this.user1     = response;
          this.interests = this.user1.split(',').map((interest) => interest.trim());
          this.loading=false;
        },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
     
    )
   }


  iniForm(){
    // Initialize the form group
    this.formGroup = this.fb.group({
      interestInput: ['', Validators.required],
      userId:[this.userId]
    });
  }
  // Add interest to the list
  addInterest() {
    const interest = this.formGroup.get('interestInput')?.value.trim();

    if (interest && !this.interests.includes(interest)) {
      this.interests.push(interest);
      this.formGroup.reset();
      this.iniForm();
      this.errorMessage = '';
    }
  }

  // Remove interest from the list
  removeInterest(interest: string) {
    this.interests = this.interests.filter((item) => item !== interest);
    this.selectedInterests = this.selectedInterests.filter((item) => item !== interest);
  }

  // Toggle selection of an interest
  toggleSelection(interest: string) {
    if (this.selectedInterests.includes(interest)) {
      this.selectedInterests = this.selectedInterests.filter((item) => item !== interest);
    } else {
      this.selectedInterests.push(interest);
    }
  }

  // Check if an interest is selected
  isSelected(interest: string): boolean {
    return this.selectedInterests.includes(interest);
  }

  ngOnInit(): void {
    this.iniForm();
    this.GetAll(this.userId);
  }

  // Submit the form
  submitForm() {
    if (this.interests.length < 5) {
      this.errorMessage = "Veuillez ajouter au moins 5 centres d'intérêt avant de soumettre.";
      return;
    }
    const interestsString = this.interests.join(', ');
    this.formGroup.get('interestInput')?.setValue(interestsString);
    this.loading = true;
    this.api.update("Auth/UpdateInterests", this.formGroup.value)
    .pipe( 
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
      (
        {
          next:(response) =>
            {
              this.authResponse = response;
              if (this.authResponse.message === "OK")
                {
                   this.messageService.add({ severity: 'success', summary: 'Success', detail: this.authResponse.message });
                   this.loading = false;
                   this.GetAll(this.userId);
                } 
                else 
                {
                  this.loading = false;
                  this.GetAll(this.userId);
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: this.authResponse.message });
                }
            },
          error:(
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }

      )

    // Reset the form for further use
    this.interests = [];
    this.formGroup.reset();
    this.iniForm();
  }

}
